import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-dce691ea")

_pushScopeId("data-v-dce691ea")
const _hoisted_1 = { class: "flex flex--width flex--v flex--gap-20" }
const _hoisted_2 = { class: "text text--primary-b text--size-18 text--medium text--height-22 text--center" }
const _hoisted_3 = { class: "text text--primary-b text--size-18 text--medium text--height-22 text--center" }
const _hoisted_4 = {
  key: 0,
  class: "text text--secondary-b text--size-18 text--medium text--height-22 text--center"
}
const _hoisted_5 = { class: "flex flex--width flex--v flex--valign-c flex--gap-20" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_GenericButton = _resolveComponent("GenericButton")
  const _component_InertiaLink = _resolveComponent("InertiaLink")
  const _component_Plane = _resolveComponent("Plane")
  const _component_MainPage = _resolveComponent("MainPage")

  return (_openBlock(), _createBlock(_component_MainPage, {
    title: _ctx.$trans('auth.verify_email')
  }, {
    default: _withId(() => [
      _createVNode(_component_Plane, {
        class: "verify-email-plane",
        darker: true
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode("span", _hoisted_2, _toDisplayString(_ctx.$trans("auth.verify_email_1")), 1),
            _createVNode("span", _hoisted_3, _toDisplayString(_ctx.$trans("auth.verify_email_2")), 1),
            (_ctx.verificationLinkSent)
              ? (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(_ctx.$trans("auth.verify_email_sent")), 1))
              : _createCommentVNode("", true),
            _createVNode("form", {
              class: "full-width",
              onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
            }, [
              _createVNode("div", _hoisted_5, [
                _createVNode(_component_GenericButton, {
                  class: "verify-email-button",
                  title: _ctx.$trans('auth.verify_email_resend_mail'),
                  disabled: _ctx.form.processing,
                  onClick: _ctx.submit
                }, null, 8, ["title", "disabled", "onClick"]),
                _createVNode(_component_InertiaLink, {
                  href: _ctx.route('logout'),
                  method: "post",
                  class: "inertia-link text text--less-gap text--primary-b text--size-16 text--center"
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$trans("auth.logout")), 1)
                  ]),
                  _: 1
                }, 8, ["href"])
              ])
            ], 32)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
})